module.exports = __webpack_public_path__ + "img/PH.00e01c42.svg";